
<!-- MODAL ICONS  -->
<div 
    class="modal fade" 
    [id]="modalId" 
    tabindex="-1" 
    role="dialog" 
    aria-labelledby="modelTitleId" 
    aria-hidden="true"
    >
    <div 
        class="modal-dialog modal-dialog-centered" 
        role="document"
        >
        <div 
            class="modal-content rounded" 
            [ngClass]="{'bg-dark white-text': isDarkmode}"
            >
            <app-header-title
                closeButton="closeButtonSelector"
                title="web_titles.title_icon"
                [modalId]="modalId"
                >
            </app-header-title>
            <div class="modal-body scrollable">
                <div 
                    *ngFor="let icon of icons"
                    class="container" 
                    [ngClass]="{'white-text': isDarkmode}"
                    >
                    <h2 [ngClass]="{'white-text':isDarkmode}">{{icon.groupName}}</h2>
                    <div class="row mb-4">
                        <div 
                            class="col-3 mt-2 pointer" 
                            *ngFor="let iconName of icon.iconsNames;"
                            >
                            <img 
                                src="assets/images/icon-cat/{{iconName}}.svg" 
                                alt="{{iconName}}" 
                                width="70" 
                                (click)="selectIcon(iconName)" 
                                data-bs-dismiss="modal" 
                                [ngClass]="{'filter-white': isDarkmode}"
                                >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>